// Módulo Angular para el componente EmployeeMultiSelectComponent
// Este módulo exporta el componente para que pueda ser usado en otros módulos

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { EmployeeMultiSelectComponent } from "./employee-multi-select.component";
import { SharedModule } from "../../../shared/shared.module";

@NgModule({
    declarations: [EmployeeMultiSelectComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatPaginatorModule,
        SharedModule,
    ],
    exports: [EmployeeMultiSelectComponent],
})
export class EmployeeMultiSelectModule {}
